module.exports = __webpack_public_path__ + "img/fun_yysb.0b2eeae8.jpg";